document.addEventListener("DOMContentLoaded", function() {
    var subscriptionWidget = document.querySelector('.recharge-subscription-widget');
    var targetWidget = document.querySelector('.rwidget');
    
    if (subscriptionWidget && targetWidget) {
        targetWidget.appendChild(subscriptionWidget);
    }
});

document.querySelectorAll(".product-description.alt li").forEach(li => {
    if (li.textContent.includes("SUSTAINABLY")) {
        li.classList.add("i1");
    }

    if (li.textContent.includes("ANTIBIOTIC")) {
        li.classList.add("i2");
    }

    if (li.textContent.includes("HUMANELY")) {
        li.classList.add("i3");
    }
});

(function ($) {
    "use strict";
    jQuery(document).ready(function ($) {

        $(document).ready(function() {

          const updateClassBasedOnPrice = () => {
            const priceElement = $('body.custom-box .rb-price span');
            const btnWrapper = $('body.custom-box .rb-btn-wrapper');
            if (btnWrapper.find("small").length === 0) { 
              btnWrapper.append("<small>Min Order Value must be 225$</small>");
            } 
            
            if (priceElement.length && btnWrapper.length) {
              const priceText = priceElement.text().trim();
              const price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        
              if (price > 224) {
                btnWrapper.removeClass('min-price-tag'); 
               
              } else {
                btnWrapper.addClass('min-price-tag');
              }
            }
          };
        
          updateClassBasedOnPrice();
        
          setInterval(updateClassBasedOnPrice, 500);
        });
      
        $(document).ready(function () {
          setInterval(function () {
            const $progressBar = $('.rb-progress-bar');
            const rbAdded = parseInt($progressBar.attr('data-rb-added'), 10);
            const rbLeft = parseInt($progressBar.attr('data-rb-left'), 10);
        
            if (!isNaN(rbAdded) && !isNaN(rbLeft)) {
              const totalCuts = rbAdded + rbLeft;
              const message = `${rbAdded} of ${totalCuts} cuts selected`;
        
              const $wrapper = $('.rb-progress-bar-wrapper');
              $wrapper.find('small').remove();
        
              const $small = $('<small>').text(message);
        
              if (rbLeft === 1) {
                $small.addClass('cuts-complete');
              }

              if (rbLeft === 0) {
                $small.addClass('cuts-complete');
              }
              
              $wrapper.append($small);
            }
          }, 1000);
        });
      
      
      $(document).ready(function () {
            function updateActiveClass() {
                $(".rb-box-builder > div[data-id]").each(function () {
                    var $this = $(this);
                    var dataId = $this.data("id");
                    var rect = $this[0].getBoundingClientRect();
        
                    if (rect.top >= 0 && rect.top <= 100) {
                        $(".sidebar-filters li").removeClass("sfchecked");
                        $(".sidebar-filters li[data-id='" + dataId + "']").addClass("sfchecked");
                    }
                });
        
                if (!$(".sidebar-filters li.sfchecked").length) {
                    $(".sidebar-filters li:first").addClass("sfchecked");
                }

                var activeFilterId = $(".sidebar-filters li.sfchecked").data("id");
                if (activeFilterId) {
                    $(".filter-cuts").attr("data-filter-cut", activeFilterId);
                }
              
            }
        
            $(window).on("scroll", updateActiveClass);
        
            updateActiveClass();
        });
            
        $(document).ready(function() {
            $("a").each(function() {
                if (this.hostname && this.hostname !== window.location.hostname) {
                    $(this).attr("target", "_blank"); // Opens link in a new tab
                    $(this).attr("rel", "noopener noreferrer"); // Adds security for external links
                }
            });
        });
      
        $(document).ready(function(){
          $(".header-search").click(function(event){
            event.stopPropagation(); // Prevent click from propagating to the document
            $("body").toggleClass("search-open");
          });
        
          // Close search when clicking outside of .header-search and .search-wrap
          $(document).click(function(event) {
            if (!$(event.target).closest('.header-search, .search-wrap').length && $("body").hasClass("search-open")) {
              $("body").removeClass("search-open");
            }
          });
        });
      
        $(document).ready(function() {
          $('.jarallax').jarallax();
        });
    
        $('.product-gallery').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
        });
      
        $('.hero-slider').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
        });

        $('.pr-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 5000,
            fade: true,
        });
        
        $('.three-column-slider').slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1050,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        dots:true
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        dots:true
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        centerMode: false,
                        dots:true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        dots:true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        dots:true
                    }
                }

              ]
        });
      
        $('.testimonial-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1050,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        adaptiveHeight: true,                      
                    }
                }

              ]
        });

        $('#menu_trigger').on('click', function () {
            $('.mainmenu').toggleClass('active');
        });
        $('#menu_close').on('click', function () {
            $('.mainmenu').removeClass('active');
        });


    });

}(jQuery));

gsap.registerPlugin(ScrollTrigger);
// Function to wrap each letter in a span while preserving spaces
const splitText = (element) => {
    if (window.innerWidth > 1 && element) {
        let text = element.innerText;

        // Split by words and wrap each word in a span
        element.innerHTML = text.split(" ").map(word => {
            return `<span class="word">${word}</span>`;
        }).join(" "); // Rejoin words with a regular space
    }
};


// Select both loading text elements
const loadingText1 = document.querySelector(".loading_text");
const loadingText2 = document.querySelector(".loading_text_2");

// Split the text into spans for both loading texts
splitText(loadingText1);
splitText(loadingText2);

// Create ScrollTrigger animation for the first loading text
const scrollTriggerAnimation1 = () => {
    gsap.fromTo(".loading_text span", {
        force3D: true,
        color: "#F2F0E9" // Initial color of the text
    }, {
        color: "#FC4C02", // Target color for the text
        stagger: 0.25, // Delay between each letter
        scrollTrigger: {
            trigger: "#interaction", // Section to trigger the animation
            start: "top 85px", // Pin the section when its top hits the viewport top
            end: "bottom top", // Release pin when the bottom of the section hits the viewport top
            pin: true,
            scrub: true,
            anticipatePin: 1,
        }
    });
};

// Create ScrollTrigger animation for the second loading text
const scrollTriggerAnimation2 = () => {
    gsap.fromTo(".loading_text_2 span", {
        force3D: true,
        color: "#ffffff" // Initial color of the text
    }, {
        color: "#FC4C02", // Target color for the text
        stagger: 0.25, // Delay between each letter
        scrollTrigger: {
            trigger: "#interaction2", // Section to trigger the animation
            start: "top 70%",
            end: "bottom 50%",
            pin: false,
            scrub: true,
        }
    });
};

// Check if media query is matched and apply the correct animation
const setupAnimations = () => {
    const mediaQuery = window.matchMedia("(min-width: 10px)");
    const setupAnimation = (e) => {
        if (e.matches) {
            scrollTriggerAnimation1();  // Enable animation for the first text
            scrollTriggerAnimation2();  // Enable animation for the second text
        } else {
            // If viewport is smaller, kill all ScrollTriggers
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        }
    };

    mediaQuery.addListener(setupAnimation);
    setupAnimation(mediaQuery);  // Initial check for media query
};

setupAnimations();